// AI課題(Design Challenge with AI 2026)の閲覧期限。これ以降は全ての AI課題ページを閲覧できない(RFSSN-9255)
// 「3/31 いっぱいは閲覧可、4/1 0:00 から閲覧不可」。red-career-front の VIEWING_DEADLINE と同じ値
export const designChallenges2026ViewingDeadline = '2027-03-31T23:59:59+09:00'
